import React, { Component, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

import { useStyles } from "../../../../../../Components/CSS/FormStyle.css";

class AddExamSubjects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ref: {
        fullRef: createRef(),
        passRef: createRef(),
      },
    };
  }

  handleWheel = (refValue) => {
    refValue.current.blur();
    setTimeout(() => refValue.current.focus(), 100);
  };

  handleEdit = (editIndex, data) => {
    this.props.handleEditSubject(editIndex, data);
    let initData = {
      name: "",
      date: "",
      startTime: "",
      endTime: "",
      fullMarks: 0,
      passMarks: 0,
    };
    this.props.handleEditSubjectChange(initData);
    this.props.handleCancelEdit(this.props.handleCancelEditBody);
  };

  render() {
    const {
      classes,
      subjectList,
      editIndex,
      data,
      editStatus,
      handleSubjectChange,
      handleSubjectSubmit,
    } = this.props;
    return (
      <div>
        <TextField
          name="name"
          select
          label="Subject Name"
          required
          fullWidth
          variant="outlined"
          margin="normal"
          helperText={
            subjectList.length === 0
              ? "Select Subject"
              : "Select class to get subjects"
          }
          SelectProps={{
            native: true,
          }}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          className={classes.inputWithMargin}
          value={data.name}
          onChange={handleSubjectChange}
        >
          <option value="">Select Any One</option>
          {subjectList.length !== 0 &&
            subjectList.map((data) =>
              data.map((subject, index) => (
                <option key={index} value={subject.name}>
                  {subject.name}
                </option>
              ))
            )}
        </TextField>
        <TextField
          name="date"
          type="date"
          label="Exam Date"
          required
          fullWidth
          variant="outlined"
          margin="normal"
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          className={classes.inputWithMargin}
          value={data.date}
          onChange={handleSubjectChange}
        />
        <TextField
          name="startTime"
          type="time"
          label="Start Time"
          required
          fullWidth
          variant="outlined"
          margin="normal"
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          className={classes.inputWithMargin}
          value={data.startTime}
          onChange={handleSubjectChange}
        />
        <TextField
          name="endTime"
          type="time"
          label="End Time"
          required
          fullWidth
          variant="outlined"
          margin="normal"
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          className={classes.inputWithMargin}
          value={data.endTime}
          onChange={handleSubjectChange}
        />
        <TextField
          name="fullMarks"
          type="number"
          label="Full Marks"
          required
          fullWidth
          variant="outlined"
          margin="normal"
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
            inputProps: {
              min: 0,
              max: 100,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          className={classes.inputWithMargin}
          inputRef={this.state.ref.fullRef}
          onWheel={() => this.handleWheel(this.state.ref.fullRef)}
          value={data.fullMarks}
          onChange={handleSubjectChange}
        />
        <TextField
          name="passMarks"
          type="number"
          label="Pass Marks"
          required
          fullWidth
          variant="outlined"
          margin="normal"
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
            inputProps: {
              min: 0,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          className={classes.inputWithMargin}
          inputRef={this.state.ref.passRef}
          onWheel={() => this.handleWheel(this.state.ref.passRef)}
          value={data.passMarks}
          onChange={handleSubjectChange}
        />

        <Button
          variant="outlined"
          onClick={
            editStatus
              ? () => this.handleEdit(editIndex, data)
              : handleSubjectSubmit
          }
          className={classes.buttonStyle}
        >
          {editStatus ? "Edit Subjects" : "Add Subjects"}
        </Button>
      </div>
    );
  }
}

export default withStyles(useStyles)(AddExamSubjects);
